import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import SmoothScroll from "@/components/SmoothScroll";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import ProductPage from "@/pages/ProductPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderConfirmedPage from "@/pages/OrderConfirmedPage";
import OrderCancelledPage from "@/pages/OrderCancelledPage";
import BookingConfirmedPage from "@/pages/BookingConfirmedPage";
import BookingCancelledPage from "@/pages/BookingCancelledPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import { api } from "@/lib/api";

// Fires an anonymous page-view ping on every route change so the admin panel
// can show live traffic. Skips the /admin routes so the owner's own visits
// don't inflate the numbers.
function PageTracker() {
  const location = useLocation();
  useEffect(() => {
    if (location.pathname.startsWith("/admin")) return;
    api
      .post("/track", {
        path: location.pathname + location.search,
        referrer: document.referrer || "",
        screen: `${window.screen.width}x${window.screen.height}`,
      })
      .catch(() => {});
  }, [location.pathname, location.search]);
  return null;
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <SmoothScroll>
              <PageTracker />
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/shop/:slug" element={<ProductPage />} />
                <Route path="/checkout" element={<CheckoutPage />} />
                <Route path="/order/confirmed" element={<OrderConfirmedPage />} />
                <Route path="/order/cancelled" element={<OrderCancelledPage />} />
                <Route path="/booking/confirmed" element={<BookingConfirmedPage />} />
                <Route path="/booking/cancelled" element={<BookingCancelledPage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminDashboardPage />} />
              </Routes>
              <CartDrawer />
            </SmoothScroll>
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
